import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';


@Injectable({
  providedIn: 'root'
})
export class CompetitionsService {
  private BASE_URL = environment.apiUrl + 'api';

  constructor(private http: HttpClient) { }

  getCompetitions(): Observable<any> {
    const url = `${this.BASE_URL}/competition/all`;
    return this.http.get<any>(url);
  }

}